module.exports = __webpack_public_path__ + "img/ring_chart.a7940736.svg";